import TitlePaper from "@components/atoms/TitlePaper/TitlePaper";
import { Stack, Box, Paper, InputLabel, Button } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { grey } from "@mui/material/colors";
import { Controller } from "react-hook-form";
import { IReportUI } from "src/types/organisms";
const ReportUI = ({
  control,
  onSubmit,
  isLoading
}: IReportUI) => {
  const classes = {
    mainPaper: {
      marginTop: 3,
      width: 1,
      padding: "24px"
    },
    inputLabel: {
      color: grey[900],
      marginBottom: 0.5
    }
  };
  return <Paper elevation={12} sx={classes.mainPaper}>
      <TitlePaper title="Reportes" subtitle="Genera tu informe detallado acerca de los recibos actuales." />
      <Stack direction={"row"} marginTop={2} spacing={3} alignItems={"center"}>
        <Box width={0.5}>
          <InputLabel htmlFor="startDate" sx={classes.inputLabel}>
            Desde
          </InputLabel>
          <Controller name="startDate" control={control} rules={{
          required: true
        }} render={({
          field: {
            ref,
            onChange
          }
        }) => <DatePicker sx={{
          width: 1
        }} inputRef={ref} onChange={onChange} disabled={isLoading} />} />
        </Box>
        <Box width={0.5}>
          <InputLabel htmlFor="endDate" sx={classes.inputLabel}>
            Hasta
          </InputLabel>
          <Controller name="endDate" control={control} rules={{
          required: true
        }} render={({
          field: {
            ref,
            onChange
          }
        }) => <DatePicker sx={{
          width: 1
        }} inputRef={ref} onChange={onChange} disabled={isLoading} />} />
        </Box>
        <Box minWidth={160}>
          <InputLabel sx={[classes.inputLabel, {
          visibility: "hidden"
        }]}>
            None
          </InputLabel>
          <Button fullWidth variant="outlined" onClick={onSubmit} disabled={isLoading}>
            Generar reporte
          </Button>
        </Box>
      </Stack>
    </Paper>;
};
export default ReportUI;